module.exports = __webpack_public_path__ + "static/media/instagram.68ec4fbc.svg";